import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("alsat-theme");
    const isDark = stored === "dark";
    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("alsat-theme", next ? "dark" : "light");
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      onClick={toggle}
      aria-label={dark ? "Gündüz rejiminə keç" : "Gecə rejiminə keç"}
      title={dark ? "Gündüz rejimi" : "Gecə rejimi"}
      className="relative inline-flex h-9 w-16 shrink-0 items-center rounded-full border border-border bg-muted p-1 transition-colors duration-300 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Sun
        className={`pointer-events-none absolute left-2 size-4 transition-opacity duration-300 ${
          dark ? "text-muted-foreground/70 opacity-100" : "opacity-0"
        }`}
      />
      <Moon
        className={`pointer-events-none absolute right-2 size-4 transition-opacity duration-300 ${
          dark ? "opacity-0" : "text-muted-foreground/70 opacity-100"
        }`}
      />
      <span
        className={`pointer-events-none z-10 grid size-7 place-items-center rounded-full bg-background text-primary shadow-md ring-1 ring-border transition-transform duration-300 ease-out ${
          dark ? "translate-x-7" : "translate-x-0"
        }`}
      >
        {dark ? <Moon className="size-4" /> : <Sun className="size-4" />}
      </span>
    </button>
  );
}
